import NoItemFoundComponent from "@/app/components/ui/NoItemFoundComponent";
import {
  IWalletHistoryProps,
  usePaymentUserWalletHistoryAPI,
} from "@/app/hooks/api_hooks/payment/usePaymentUserWalletHistoryAPI";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useUtils } from "@/app/hooks/useUtils";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect, useState } from "react";
import CartHeaderComponent from "../../CartBillingComponent/CartHeaderComponent";
import ViewDebitNoteModalComponent from "../ViewDebitNoteModalComponent";

const TransactionHistoryComponent = () => {
  const { getRouteKey } = useRouter();
  const { veticDateFormat, InvoicestatusBackgroundColor, InvoiceStatusDataTransformed } = useUtils();
  const { NO_CART } = useImageConstants();
  const [open, setOpen] = useState<boolean>(false);
  const [debitnoteid, setDebitnoteid] = useState(null);
  const { customerId } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState.state as ICustomerProfileState;

  const { execute: fetchTransactionHistory, transaction } = usePaymentUserWalletHistoryAPI();
  useEffect(() => {
    if (customerId) {
      const constructedBody: IWalletHistoryProps = {
        page_number: 1,
        page_size: 10,
        user_id: customerId,
      };
      fetchTransactionHistory(constructedBody);
    }
  }, [customerId]);

  const isTransactionLoading = useLoader("isCustomerTransactionTableInProgress");

  return (
    <div className="h-full">
      <div className="pb-0.5 rounded-lg bg-white px-2">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-2 gap-2">
          <p className="text-sm font-semibold mt-2">Transactions</p>
        </div>
        <CartHeaderComponent />
      </div>
      {isTransactionLoading ? (
        <TableSkeleton />
      ) : transaction?.payment_history_data?.length > 0 ? (
        <div className="mt-2 scroll-inner !h-auto max-h-[520px] sm:max-h-[650px] flow-root relative rounded-xl bg-[#F9FAFB] overflow-auto">
          <div className="w-full">
            <div className="inline-block min-w-full align-middle">
              <table className="w-full min-w-[980px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                <thead className="bg-[#F5F5F5] text-[#1F1F23] font-normal sticky top-0 z-20">
                  <tr>
                    {tableHeader.map((key, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black tracking-wider"
                      >
                        {key.item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transaction?.payment_history_data?.map((cl, index) => {
                    const isFirst = index === 0;
                    const isLast = index === transaction.payment_history_data.length - 1;
                    const isSingle = transaction.payment_history_data.length === 1;

                    return (
                      <tr
                        key={index}
                        className={`
                          bg-white
                          ${isSingle ? "rounded-xl" : ""}
                          ${isFirst && !isSingle ? "rounded-t-xl" : ""}
                          ${isLast && !isSingle ? "rounded-b-xl" : ""}
                        `}
                      >
                        <td
                          className={`
                            whitespace-nowrap px-2 py-3 text-xs text-black flex flex-col
                            ${isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tl-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-bl-2xl" : ""}
                          `}
                        >
                          <span className="capitalize">{cl?.receipt_type === "payments" && "payment"}</span>
                          <span className="capitalize">{cl?.receipt_type === "invoices" && "invoice"}</span>
                          <span className="capitalize">{cl?.receipt_type === "debit_notes" && "debit note"}</span>
                          {cl?.receipt_type?.toLowerCase() === "invoices" ? (
                            <span>
                              <a
                                className="text-[10px] text-blue-400 font-medium cursor-pointer p-0 m-0"
                                href={cl?.pdf_url}
                                target="_blank"
                              >
                                {cl?.receipt_id}
                              </a>
                            </span>
                          ) : cl?.receipt_type === "payments" ? (
                            <span
                              className="text-[10px] text-blue-400 font-medium cursor-pointer p-0 m-0"
                              // onClick={() => {
                              //   setOpen(true);
                              //   setDebitnoteid(cl?.receipt_id);
                              // }}
                            >
                              {cl?.receipt_id}
                            </span>
                          ) : (
                            <span
                              className="text-[10px] text-blue-400 font-medium cursor-pointer p-0 m-0"
                              onClick={() => {
                                setOpen(true);
                                setDebitnoteid(cl?.receipt_id);
                              }}
                            >
                              {cl?.receipt_id}
                            </span>
                          )}
                        </td>
                        <td className="whitespace-nowrap px-2 py-3 text-xs text-black">
                          <button
                            className={`${InvoicestatusBackgroundColor(cl?.status?.toLowerCase() || "")} py-1 px-3 rounded-full text-[#000000] capitalize`}
                          >
                            {InvoiceStatusDataTransformed(cl?.status || "NA")}
                          </button>
                        </td>
                        <td className="whitespace-nowrap px-2 py-3 text-xs text-black">
                          {cl?.created_at ? veticDateFormat(cl?.created_at) : "NA"}
                        </td>
                        <td
                          className={`whitespace-nowrap px-2 py-3 text-xs text-[#FF0303] ${cl?.status?.toLowerCase() === "cancelled" && "line-through"}`}
                        >
                          {cl?.debit_amount}
                        </td>
                        <td
                          className={`whitespace-nowrap px-2 py-3 text-xs text-[#079F60] ${cl?.status?.toLowerCase() === "cancelled" && "line-through"}`}
                        >
                          {cl?.credit_amount}
                        </td>
                        <td
                          className={`whitespace-nowrap px-2 py-3 text-xs text-black ${cl?.status?.toLowerCase() === "cancelled" && "line-through"}`}
                        >
                          {cl?.payment_mode ? cl?.payment_mode : "-"}
                        </td>
                        <td
                          className={`
                            whitespace-nowrap px-2 py-3 text-xs text-gray-500
                            ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                          `}
                        >
                          {cl?.created_by}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="text-xs bg-[#F5F5F5] font-medium">
                    <td colSpan={3} className="sticky bottom-0 z-20 text-right px-6 py-3 bg-[#F5F5F5] border-t rounded-bl-2xl">
                      Total Value:
                    </td>
                    <td className="sticky bottom-0 z-20 px-2 py-3 bg-[#F5F5F5] border-t text-[#FF0303]">
                      {transaction?.total_debit}
                    </td>
                    <td className="sticky bottom-0 z-20 px-2 py-3 bg-[#F5F5F5] border-t text-[#079F60]">
                      {transaction?.total_credit}
                    </td>
                    <td colSpan={2} className="sticky bottom-0 z-20 px-2 py-3 bg-[#F5F5F5] border-t rounded-br-2xl"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {debitnoteid && <ViewDebitNoteModalComponent setOpen={setOpen} open={open} debitnoteid={debitnoteid} />}
        </div>
      ) : (
        transaction?.payment_history_data?.length === 0 && (
          <div className="bg-white h-[400px] mt-3">
            <NoItemFoundComponent
              message=""
              description="No Transaction Found"
              imageURL={NO_CART}
              InputClassName="my-0 h-full"
            />
          </div>
        )
      )}
    </div>
  );
};

export default TransactionHistoryComponent;
const tableHeader = [
  { item: "Type" },
  { item: "Status" },
  { item: "Date & Time" },
  { item: "Debit" },
  { item: "Credit" },
  { item: "Payment Mode" },
  { item: "Created By" },
];
const TableSkeleton = () => {
  return (
    <div className="mt-3 scroll-inner !h-auto max-h-[520px] sm:max-h-[650px] flow-root relative rounded-xl bg-[#F9FAFB] animate-pulse">
      <div className="w-full overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <table className="w-full min-w-[980px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
            <thead className="bg-[#F5F5F5] text-[#1F1F23] font-normal sticky top-0 z-10">
              <tr>
                {[...Array(7)].map((_, index) => (
                  <th key={index} className="p-2 py-3 text-left text-xs font-medium text-gray-300 tracking-wider">
                    <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(8)].map((_, rowIndex) => (
                <tr key={rowIndex} className="bg-white">
                  {[...Array(7)].map((_, colIndex) => (
                    <td key={colIndex} className="px-2 py-3 whitespace-nowrap text-xs text-gray-300">
                      <div className="h-3 bg-gray-200 rounded w-full"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
